import {Grid} from '../../../components/utility/grid.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';
import {Table} from '../../../components/table/table.tsx';
import {TableRow} from '../../../components/table/table_row.tsx';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {LocationType} from '../../../gql/pwa/graphql.ts';
import {getBreakTimes, getOpeningHours} from '../../../support/get_data.ts';
import {defaultOpeningHourTypes, OpeningHourTypes} from '../../../enums/opening_hour_types.ts';

interface OwnProps {
    location: LocationType;
}

export function OpeningHours({location}: OwnProps) {
    const locationOpeningHours = location.opening_hours;
    const oneHasBreakTimes =
        locationOpeningHours &&
        defaultOpeningHourTypes.some((openingHourType) => getBreakTimes(locationOpeningHours, openingHourType));
    return (
        <>
            {locationOpeningHours &&
            locationOpeningHours.some(
                (openingHour) =>
                    openingHour &&
                    openingHour.type &&
                    defaultOpeningHourTypes.indexOf(openingHour.type as OpeningHourTypes) > -1,
            ) ? (
                <Grid>
                    {defaultOpeningHourTypes.map((openingHourType) => {
                        const openingHours = getOpeningHours(locationOpeningHours, openingHourType);
                        const breakTimes = getBreakTimes(locationOpeningHours, openingHourType);
                        if (openingHours.length) {
                            return (
                                <div key={'opening-hours-' + location.id + '-' + openingHourType}>
                                    <FlexRow alignment={Alignment.Center}>
                                        <h2>{__(`enums.opening_hours.${openingHourType}`)}</h2>
                                    </FlexRow>

                                    <Table>
                                        {breakTimes.length ? (
                                            <TableRow columns={1}>
                                                <TableCell
                                                    name={''}
                                                    value={__('contact.table.open')}
                                                    secondaryValue={__('contact.table.break')}
                                                />
                                            </TableRow>
                                        ) : (
                                            oneHasBreakTimes === true && (
                                                <TableRow columns={1}>
                                                    <TableCell name={''} value={''} />
                                                </TableRow>
                                            )
                                        )}
                                        {openingHours.map((openingHour, index) => {
                                            return breakTimes.length ? (
                                                <TableRow
                                                    columns={1}
                                                    key={
                                                        'opening-hour-' +
                                                        location.id +
                                                        '-' +
                                                        openingHour.day +
                                                        '-' +
                                                        openingHour.time +
                                                        '-' +
                                                        index
                                                    }
                                                >
                                                    <TableCell
                                                        name={openingHour.day}
                                                        value={openingHour.time}
                                                        secondaryValue={breakTimes[index].time}
                                                    />
                                                </TableRow>
                                            ) : (
                                                <TableRow
                                                    columns={1}
                                                    key={
                                                        'opening-hour-' +
                                                        location.id +
                                                        '-' +
                                                        openingHour.day +
                                                        '-' +
                                                        openingHour.time +
                                                        '-' +
                                                        index
                                                    }
                                                >
                                                    <TableCell name={openingHour.day} value={openingHour.time} />
                                                </TableRow>
                                            );
                                        })}
                                    </Table>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}
                </Grid>
            ) : (
                <FlexRow alignment={Alignment.Center}>
                    <h3>{__('contact.titles.no_opening_hours')}</h3>
                </FlexRow>
            )}
        </>
    );
}
